import { j as w } from "./jsx-runtime.DGlMoOmv.js";
import { c as l } from "./index.C4-GUKyp.js";
import * as i from "react";
import { c as d } from "./index.CxSWpsOB.js";
const u = l("tw-px-12 tw-py-8 focus:tw-outline focus:tw-outline-2 focus:tw-outline-blue-800 focus:tw-outline-offset-1 tw-border-gray-400 focus:tw-border-gray-900 tw-border tw-rounded-4 tw-inline-block tw-text-gray-900 placeholder:tw-text-gray-600 disabled:tw-text-gray-500 disabled:placeholder:tw-text-gray-500 tw-bg-base-white tw-min-h-[144px] tw-align-top", {
  variants: {
    fullWidth: {
      true: "tw-w-full",
      false: ""
    },
    error: {
      true: "tw-border-red-800 focus:tw-border-red-800"
    }
  }
}), f = i.forwardRef(({
  className: t,
  errorMsg: e,
  fullWidth: r,
  testId: a = "textarea",
  ...o
}, s) => /* @__PURE__ */ w.jsx("textarea", { ref: s, "data-testid": a, className: d(u({
  fullWidth: !!r,
  error: !!e,
  className: t
})), ...o }));
f.displayName = "Textarea";
export {
  f as T
};
//# sourceMappingURL=Textarea.BsmL3mV8.js.map
